<template>
  <div
    class="p-6 bg-white max-w-[1200px] mx-auto px-[200px]"
    style="max-width: 1200px"
  >
    <!-- 概览 -->
    <div class="mb-8">
      <h3 class="text-[16px] font-bold mb-4">概览</h3>
      <div class="space-y-4">
        <div class="flex items-center">
          <label class="w-32 text-sm text-gray-700">广告系列名称</label>
          <el-input
            v-model="campaignCurrentName"
            placeholder="输入您想要的名称"
            class="flex-1"
            @input="setName"
          />
        </div>
        <div class="flex items-center">
          <label class="w-32 text-sm text-gray-700">广告系列类型</label>
          <span class="text-sm">搜索</span>
        </div>
        <div class="flex items-center">
          <label class="w-32 text-sm text-gray-700">目标</label>
          <span class="text-sm">销售</span>
        </div>
        <div class="flex items-center">
          <label class="w-32 text-sm text-gray-700">目标</label>
          <span class="text-sm">购买</span>
        </div>
      </div>
    </div>

    <!-- 预算出价 -->
    <div class="mb-8">
      <h3 class="text-[16px] font-bold mb-4">预算出价</h3>
      <div class="space-y-4">
        <BudgetBidding
          ref="budgetComponent"
          :value="{
            bidAmount: formData.bidAmount,
            bidStrategy: formData.bidStrategy,
            budgetAmount: formData.budgetAmount,
            budgetType: formData.budgetType,
            startDate: formData.startDate,
          }"
          @input="handleBudgetChange"
          :enumConstants="enumConstants"
          :createAdAccount="createAdAccount"
        />
      </div>
    </div>

    <!-- 广告系列 -->
    <div class="mb-8">
      <h3 class="text-[16px] font-bold mb-4">广告系列</h3>
      <div class="space-y-4">
        <div class="flex items-center">
          <label class="w-32 text-sm text-gray-700">投放网络</label>
          <span class="text-sm">Google搜索网络，搜索网络合作伙伴，展示广告网络</span>
        </div>
        <div class="flex items-center">
          <label class="w-32 text-sm text-gray-700">地理位置</label>
          <span class="text-sm">{{ locations }}</span>
        </div>
        <div class="flex items-center">
          <label class="w-32 text-sm text-gray-700">语言</label>
          <span class="text-sm">{{ languages }}</span>
        </div>
        <div class="flex items-center">
          <label class="w-32 text-sm text-gray-700">受众群体广告</label>
          <span class="text-sm">不包含受众群体广告</span>
        </div>
        <div class="flex items-center">
          <label class="w-32 text-sm text-gray-700">受众群体</label>
          <span class="text-sm">没有细分受众</span>
        </div>
      </div>
    </div>

    <!-- AI Max -->
    <div class="mb-8">
      <h3 class="text-[16px] font-bold mb-4">AI Max</h3>
      <div class="space-y-4">
        <div class="flex items-center">
          <label class="w-32 text-sm text-gray-700">优化素材资源</label>
          <span class="text-sm">文案适配和最终到达网址扩展功能已停用</span>
        </div>
        <div class="flex items-center">
          <label class="w-32 text-sm text-gray-700">品牌</label>
          <span class="text-sm">仅限0个品牌列表，排除0个品牌列表</span>
        </div>
      </div>
    </div>

    <!-- 关键字广告 -->
    <div class="mb-8">
      <h3 class="text-[16px] font-bold mb-4">关键字广告</h3>
      <div class="space-y-4">
        <div class="flex items-center">
          <label class="w-32 text-sm text-gray-700">关键字</label>
          <span class="text-sm">{{ keywordsCount }}个关键字</span>
        </div>
        <div class="flex items-center">
          <label class="w-32 text-sm text-gray-700">搜索字词匹配</label>
          <span class="text-sm">仅使用您的关键字和匹配类型</span>
        </div>
        <div class="flex items-center">
          <label class="w-32 text-sm text-gray-700">限定品牌</label>
          <span class="text-sm">仅限0个品牌列表</span>
        </div>
        <div class="flex items-center">
          <label class="w-32 text-sm text-gray-700">感兴趣的地理位置</label>
          <span class="text-sm">无</span>
        </div>
        <div class="flex items-center">
          <label class="w-32 text-sm text-gray-700">网址包含对象</label>
          <span class="text-sm">未添加任何网址包含对象</span>
        </div>
        <div class="flex items-center">
          <label class="w-32 text-sm text-gray-700">广告</label>
          <span class="text-sm">1个广告</span>
        </div>
      </div>
    </div>
    <config-upload
      :creatFormShow.sync="creatFormShow"
      @creatAd="creatAd"
    ></config-upload>
  </div>
</template>

<script>
import { create } from 'lodash';
import BudgetBidding from './BudgetBidding.vue';
import { createSearchCampaign } from '@/api/google/create';
import configUpload from '@/views/google/create/components/configUpload/index.vue';
export default {
  name: 'Preview',
  components: {
    BudgetBidding,
    configUpload,
  },
  props: {
    enumConstants: {
      type: Object,
      default: () => ({}),
    },
    createAdAccount: {
      type: Object,
      default: () => ({}),
    },
    previewData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      campaignName: this.previewData.name,
      isNameModified: false,
      creatFormShow: false,
    };
  },
  computed: {
    formData: {
      get() {
        return { ...this.previewData };
      },
      set(value) {
        // 更新previewData以保持数据同步
        this.$emit('update:previewData', value);
      },
    },
    campaignCurrentName: {
      get() {
        return this.isNameModified ? this.campaignName : this.previewData.name;
      },
      set(value) {
        this.campaignName = value;
      },
    },
    languages() {
      let langIds = this.formData.campaignCriterion?.target.languages || [];
      let languagesList = this.enumConstants.languages;
      return languagesList
        .filter((item) => langIds.includes(item.id))
        .map((item) => item.nameZhcn)
        .join('、');
    },
    locations() {
      let locations = this.formData.campaignCriterion?.target.locations || [];
      return locations.map((item) => item.name).join('、');
    },
    keywordsCount() {
      let keywords = this.previewData.adGroups?.[0]?.ads?.[0]?.headlines || [];
      console.log('keywords', keywords);
      return keywords.length;
    },
  },
  methods: {
    handleBudgetChange(value) {
      // 直接更新previewData的引用，避免创建新对象
      Object.assign(this.previewData, value);
      this.$emit('setBidMsg', value);
    },
    setName(v) {
      this.campaignName = v;
      this.isNameModified = true;
    },
    createCampaign() {
      this.creatFormShow = true;
    },
    creatAd(params) {
      this.$showLoading();
      createSearchCampaign({ ...this.formData, name: this.campaignCurrentName, ...params })
        .then((res) => {
          this.$hideLoading();
          this.creatFormShow = false;
          if (res.code !== 0) {
            return;
          }
          this.$confirm('跳转到草稿箱，或者重新创建一个广告', '提示', {
            confirmButtonText: '再创建一个',
            cancelButtonText: '回到草稿箱',
          })
            .then((res) => {
              this.$parent.currentCreateStep = 1;
            })
            .catch((res) => {
              this.$router.push({
                name: 'googleAd',
                query: {
                  account_id: this.createAdAccount.id,
                  credentialUserId: localStorage.getItem('googleCredentialUserId'),
                },
              });
              this.$store.commit('googleAdActiveTab/setActiveTab', 'drafBox');
            });
        })
        .catch((res) => {
          this.$hideLoading();
        });
    },
  },
  watch: {
    // 'previewData.name'(newVal) {
    //   if (!this.isNameModified) {
    //     this.campaignName = newVal;
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.el-input {
  @apply border border-gray-300;
}

.el-button {
  @apply px-3 py-1 text-sm;
}
</style>
